import React from 'react';

import { connect } from 'react-redux';
import { Route, Redirect } from 'react-router-dom';
import NotEnabled from 'screens/MSTeams/common/NotEnabled';
import { selectIsAuthenticated } from 'selectors/loggedInEmployee';
import { checkModuleEnabled } from 'utils/helpers/moduleAccess';

import { DEMO_APP_DOMAIN } from 'constants/ProjectConstants';
import { routes } from 'constants/routes';

// import { useAuth } from "./context/auth";

function PrivateRoute({ isAuthenticated, featureKey = null, isTeamsVisitor = false, component: Component, ...rest }) {
  let featureEnabled = true;

  // ALL FEATURE FLAGS SHOULD ONLY BE ENABLED FOR DEMO APP
  if (window.location.host !== DEMO_APP_DOMAIN) {
    if (Array.isArray(featureKey)) {
      featureEnabled = featureKey.some((key) => checkModuleEnabled(key));
    } else {
      featureEnabled = featureKey ? checkModuleEnabled(featureKey) : true;
    }
  }

  return (
    <Route
      {...rest}
      render={(props) =>
        isAuthenticated ? (
          featureEnabled ? (
            <Component {...props} />
          ) : isTeamsVisitor ? (
            <NotEnabled />
          ) : (
            <Redirect to={{ pathname: routes.home }} />
          )
        ) : (
          <Redirect to={{ pathname: routes.login, state: { referer: props.location } }} />
        )
      }
    />
  );
}

const mapStateToProps = (state, ownProps) => ({
  isAuthenticated: selectIsAuthenticated(state),
});

export default connect(mapStateToProps, null)(PrivateRoute);
